import { ListItem, ListItemText, Typography, Box } from '@mui/material';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import React from 'react';

interface IProps {
  list: number[];
  title: string;
}

function renderRow(props: ListChildComponentProps) {
  const { index, style } = props;

  return (
    <ListItem style={style} key={index} component='div'>
      <ListItemText primary={`Item ${index + 1}`} />
    </ListItem>
  );
}

export function ListScrollComponent({ list, title }: IProps) {
  return (
    <Box
      sx={{
        width: '100%',
        height: 200,
        bgcolor: 'background.paper',
        marginBottom: 2,
        border: '1px solid #dedede',
      }}
    >
      <Box
        sx={{
          padding: 1,
          borderBottom: '1px solid #dedede',
        }}
      >
        <Typography variant='subtitle2'>{`${title} - ${list.length} 개`}</Typography>
      </Box>
      <FixedSizeList
        height={160}
        width='100%'
        itemSize={24}
        itemCount={list.length}
        overscanCount={5}
      >
        {renderRow}
      </FixedSizeList>
    </Box>
  );
}
